class Link{
    constructor({isHidden = false, type = "",heading = "", title = "", url = "", hasThumbnail = true, thumbnailUrl = "", isLoading = false, isUserUploaded = false})
    {
        this.isHidden = isHidden || false,
        this.type = type,
        this.heading = heading,
        this.title = title,
        this.url = url,
        this.hasThumbnail = hasThumbnail,
        this.thumbnailUrl = thumbnailUrl,
        this.isLoading = isLoading,
        this.isUserUploaded = isUserUploaded;

    }

    toObject(){
        return {
            isHidden: this.isHidden || false,
            type:  this.type || "",
            heading: this.heading || "",
            title: this.title || "",
            url: this.url || "",
            hasThumbnail: this.hasThumbnail || true,
            thumbnailUrl: this.thumbnailUrl || "",
            isLoading: this.isLoading || false,
            isUserUploaded: this.isUserUploaded || false,
        }
    }
    
    static fromObject(link){
        return new Link({
            isHidden: link.isHidden || false,
            type:  link.type || "",
            heading: link.heading || "",
            title: link.title || "",
            url: link.url || "",
            hasThumbnail: link.hasThumbnail || true,
            thumbnailUrl: link.thumbnailUrl || "",
            isLoading:  link.isLoading || false,
            isUserUploaded: link.isUserUploaded || false,
        });
    }
}

export default Link;